/* eslint-disable no-unused-vars */
import { ControllerModel } from "../_model/ControllerModel";
import { SingletonFlowchart } from "../_service/singletonFlowchart";
import { EvaporationCitrus } from "./modelEvaporationCitrus";

class ControllerEvaporationCitrus extends ControllerModel {
    constructor() {
        super("ControllerEvaporationCitrus");

        this.setNewNode = (callback) => {
            let evaporationcitrus = new EvaporationCitrus();
            evaporationcitrus.decorate(callback);

            this.addNode(evaporationcitrus);
            SingletonFlowchart.SaveStatus()
        }

        this.loadNode = (node, callback) => {
            let evaporationcitrus = new EvaporationCitrus();
            evaporationcitrus.copyFrom(node);
            evaporationcitrus.decorate(callback);
            this.addNode(evaporationcitrus)
        }

        this.getProperties = async (node) => {
            let n = new EvaporationCitrus();
            await n.copyFrom(node);
            return n.data
        }

        this.getNode = (node) => {
            let n = new EvaporationCitrus();
            n.copyFrom(node);
            return n
        }
    }
}

export { ControllerEvaporationCitrus };